/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./src/js/formatMoney.js":
/*!*******************************!*\
  !*** ./src/js/formatMoney.js ***!
  \*******************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   formatMoney: () => (/* binding */ formatMoney)
/* harmony export */ });
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------

function formatMoney(cents, format) {
  if (typeof cents == 'string') {
    cents = cents.replace('.', '');
  }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || "${{amount}}";
  function defaultOption(opt, def) {
    return typeof opt == 'undefined' ? def : opt;
  }
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal = defaultOption(decimal, '.');
    if (isNaN(number) || number == null) {
      return 0;
    }
    number = (number / 100.0).toFixed(precision);
    var parts = number.split('.'),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
      cents = parts[1] ? decimal + parts[1] : '';
    return dollars + cents;
  }
  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
    case "amount_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 2, "'", ".");
      break;
  }
  return formatString.replace(placeholderRegex, value);
}
;

/***/ }),

/***/ "./node_modules/smooth-zoom/dist/zoom.esm.js":
/*!***************************************************!*\
  !*** ./node_modules/smooth-zoom/dist/zoom.esm.js ***!
  \***************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ Zoom)
/* harmony export */ });
function Zoom(target, options = {}) {
  const originalizer = options.originalizer || (src => src);

  const screenSize = {
    screenWidth: 0,
    screenHeight: 0,
    scrollBar: 0
  };
  const background = options.background;

  const updateScreenSize = () => {
    const {
      documentElement
    } = document;
    screenSize.screenWidth = window.innerWidth || documentElement.clientWidth;
    screenSize.screenHeight = window.innerHeight || documentElement.clientHeight;
    screenSize.scrollBar = screenSize.screenWidth - documentElement.offsetWidth;
  };

  const zoom = image => {
    const src = image.currentSrc || image.src;
    const {
      srcset
    } = image;
    const {
      screenWidth,
      screenHeight,
      scrollBar
    } = screenSize;
    const {
      width,
      height,
      left,
      top
    } = image.getBoundingClientRect();
    const wrapX = (screenWidth - scrollBar) / 2 - left - width / 2;
    const wrapY = -top + (screenHeight - height) / 2;
    const bg = document.createElement("div");
    const imageClone = document.createElement("img");
    let maxWidth = image.naturalWidth;

    const removeImage = () => {
      bg.classList.remove("zoom-bg--reveal");
      imageClone.style.transform = "";
      imageClone.addEventListener("transitionend", () => {
        bg.remove();
        image.classList.remove("zoom-original--hidden");
        imageClone.remove();
      }, {
        once: true
      });
      bg.removeEventListener("click", removeImage);
      imageClone.removeEventListener("click", removeImage);
      window.removeEventListener("scroll", removeImage);
      window.removeEventListener("resize", removeImage);
    };

    bg.classList.add("zoom-bg");

    if (background) {
      if (background === "auto") {
        const average = getAverageRGB(image);
        bg.style.background = average ? `rgb(${average.r}, ${average.g}, ${average.b})` : "rgb(0, 0, 0)";
      } else {
        bg.style.background = background;
      }
    }

    if (srcset) {
      const sizes = srcset.match(/ ([0-9]+)w/gm);

      if (sizes) {
        // Find image's largest width in 'srcset' attribute
        maxWidth = sizes.map(x => +x.trim().replace("w", "")).filter(x => !isNaN(x)).reduce((acc, cur) => Math.max(acc, cur), 0);
      }
    }

    const ratio = height / width; // Image's width shouldn't be larger than screen width

    maxWidth = Math.min(maxWidth, screenWidth); // And height too

    const maxHeight = maxWidth * ratio;

    if (maxHeight >= screenHeight) {
      maxWidth = maxWidth * screenHeight / maxHeight;
    }

    imageClone.classList.add("zoom-img");
    imageClone.src = src;
    imageClone.width = width;
    imageClone.height = height;
    bg.addEventListener("click", removeImage, {
      once: true
    });
    imageClone.addEventListener("click", removeImage, {
      once: true
    });
    window.addEventListener("scroll", removeImage, {
      once: true,
      passive: true
    });
    window.addEventListener("resize", removeImage, {
      once: true,
      passive: true
    });
    document.body.append(bg, imageClone); // Added here for causing style recalculation

    imageClone.style.top = `${top + window.scrollY}px`;
    imageClone.style.left = `${left}px`;
    imageClone.style.width = `${width}px`;
    imageClone.style.height = `${height}px`; // Hide original image

    image.classList.add("zoom-original--hidden"); // Reveal and center cloned image, scale up if needed

    const scale = maxWidth !== width ? maxWidth / width : 1;
    imageClone.style.transform = `matrix(${scale}, 0, 0, ${scale}, ${wrapX}, ${wrapY})`;
    bg.classList.add("zoom-bg--reveal");
    imageClone.addEventListener("transitionend", () => {
      // Replace image's source to original source
      imageClone.src = originalizer(src);
    }, {
      once: true
    });
  };

  const handleClick = event => {
    zoom(event.target);
  };

  const getAverageRGB = img => {
    const blockSize = 5;
    const rgb = {
      r: 0,
      g: 0,
      b: 0
    };
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    if (!ctx) return null;
    const width = canvas.width = img.naturalWidth || img.offsetWidth || img.width;
    const height = canvas.height = img.naturalHeight || img.offsetHeight || img.height;
    let data;
    let i = -4;
    let length;
    let count = 0;
    ctx.drawImage(img, 0, 0);

    try {
      data = ctx.getImageData(0, 0, width, height);
    } catch (e) {
      return null;
    }

    length = data.data.length;

    while ((i += blockSize * 4) < length) {
      ++count;
      rgb.r += data.data[i];
      rgb.g += data.data[i + 1];
      rgb.b += data.data[i + 2];
    }

    rgb.r = Math.floor(rgb.r / count);
    rgb.g = Math.floor(rgb.g / count);
    rgb.b = Math.floor(rgb.b / count);
    return rgb;
  };

  const attach = target => {
    if (!target) return;

    if (typeof target === "string") {
      document.querySelectorAll(target).forEach(addZoomEvent);
    } else if (target instanceof HTMLElement) {
      addZoomEvent(target);
    } else if (target instanceof NodeList || target instanceof Array) {
      target.forEach(addZoomEvent);
    } // Add cursor style for target


    if (typeof target === "string") {
      const style = document.createElement("style");
      const head = document.head || document.getElementsByTagName("head")[0];
      style.appendChild(document.createTextNode(`${target}{cursor:zoom-in}`));
      head.appendChild(style);
    }
  };

  const addZoomEvent = element => {
    if (!(element instanceof HTMLElement)) return;

    if (element.tagName === "IMG") {
      element.addEventListener("click", handleClick);
    } else {
      const childImg = element.querySelector("img");

      if (childImg) {
        childImg.addEventListener("click", handleClick);
      }
    }
  };

  updateScreenSize();
  window.addEventListener("resize", updateScreenSize, {
    passive: true
  });
  attach(target);
  return {
    zoom,
    attach
  };
}

function styleInject(css, ref) {
  if (ref === void 0) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') {
    return;
  }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = ".zoom-bg,.zoom-img{cursor:zoom-out;z-index:90000}.zoom-img{display:block;position:absolute;transition:transform .3s ease-in-out;will-change:transform}.zoom-bg{background:#121212;height:100vh;left:0;opacity:0;position:fixed;top:0;transition:opacity .3s ease-in-out;width:100vw;will-change:opacity}.zoom-bg.zoom-bg--reveal{opacity:.95}.zoom-original--hidden{visibility:hidden}";
styleInject(css_248z);




/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
/*!***************************!*\
  !*** ./src/js/product.js ***!
  \***************************/
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var smooth_zoom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! smooth-zoom */ "./node_modules/smooth-zoom/dist/zoom.esm.js");
/* harmony import */ var _formatMoney__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./formatMoney */ "./src/js/formatMoney.js");



/*
 BG: Init smooth-zoom, just apply the class below a zoomable image
https://github.com/marshall-ku/smooth-zoom
 */
(0,smooth_zoom__WEBPACK_IMPORTED_MODULE_0__["default"])(".zoomable");

/**
 * BG: This is a BIG function, that has alot of smaller functions. The whole purpose of this is to determine the variant options the user has selected, while highlighting the available and unavailable variants after each choice they make, and updating the price, and variant id field. This function works best when we have the first available variants selected.
 */
var productVariants = function productVariants() {
  var productVariants = document.querySelector('#product-variants');
  var radioBtns = productVariants.querySelectorAll('input[type="radio"]');
  var variantFieldsets = productVariants.querySelectorAll('fieldset');
  var masterVariantField = document.querySelector('.product-info form[action="/cart/add"] input[name="id"]');
  var cartBtn = document.querySelector('.product-info form[action="/cart/add"] button[type="submit"]');

  //get the variantData from the json markup.
  var getVariantData = function getVariantData() {
    return JSON.parse(productVariants.querySelector('[type="application/json"]').textContent);
  };

  //Debug
  //console.log(JSON.parse(productVariants.querySelector('[type="application/json"]').textContent));

  //BG: When the user makes a selection, update the field legend to include that choice.
  /**
   * 
   * @param {*} radio | Node - Passed when the user selects a radio on variant selector.
   */
  var fieldsetLegend = function fieldsetLegend(radio) {
    var parentLegend = radio.closest('fieldset');
    var legendLabel = parentLegend.querySelector('legend').getAttribute('data-fieldset-label');
    parentLegend.querySelector('legend span').innerHTML = legendLabel + ': ' + '<span class="uppercase font-bold">' + radio.value + '</span>';
  };

  //BG: Triggered by the finalVariant function, we determine if the final variant Id selected is available or not, and update the button to reflect that choice.
  var addToBagBtn = function addToBagBtn(available) {
    if (available) {
      cartBtn.classList.remove('btn-disabled');
      cartBtn.classList.add('btn-primary');
      cartBtn.innerHTML = window.product.addToCart;
      cartBtn.disabled = false;
    } else {
      cartBtn.classList.add('btn-disabled');
      cartBtn.classList.remove('btn-primary');
      cartBtn.innerHTML = window.product.soldOut;
      cartBtn.disabled = true;
    }
  };

  //BG: the finalVariant funciton below will trigger this function, we essentially need the variant ID to query the price
  var variantPrice = function variantPrice(variantId) {
    var productPrice = document.querySelector('.js-product-price');
    var productCAP = document.querySelector('.js-product-compare-at-price');
    var variantData = getVariantData().filter(function (variant) {
      return variant.id === variantId;
    });

    //Update the product price, with the selected variant, and format the money.
    productPrice.innerHTML = (0,_formatMoney__WEBPACK_IMPORTED_MODULE_1__.formatMoney)(variantData[0].price, window.theme.moneyFormat);

    //Is there a Compare at price (CAP)? if so, let's update that too. 
    if (variantData[0].compare_at_price != null) {
      //if CAP does exist, remove the hidden class if present.
      productCAP.classList.remove('hidden');
      //Update the CAP, with the selected variant, and format the money.
      productCAP.innerHTML = (0,_formatMoney__WEBPACK_IMPORTED_MODULE_1__.formatMoney)(variantData[0].compare_at_price, window.theme.moneyFormat);
    } else {
      //No CAP?, No Problem, let's just hide it.
      productCAP.classList.add('hidden');
    }
  };

  /**
   * BG: Once the user has selected all variant options, this function then triggers to update the variant ID field, price and url based on the users choice. 
   */
  var finalVariant = function finalVariant(variant) {
    //BG: let's update the id input to the selected variant id
    masterVariantField.value = variant.id;
    //BG: Trigger the price update based on the variant ID
    variantPrice(variant.id);
    //BG: Update the add to bag btn based on the variant being available or not.
    addToBagBtn(variant.available);

    //Update the url with the user's variant choice.
    //Get the current URL without parameters
    var currentURLWithoutParams = window.location.href.split('?')[0];
    //update the page url with paramters
    history.pushState(null, null, currentURLWithoutParams + '?variant=' + variant.id);
  };

  /**
   * BG: There's a lot going on here, basically we determine how many variant options there are, and based on how many options there are, will determine the logic and approach. Essentially, we're determining what options are available or not available based on the user's choice. 
   * checkedBtns(Array) - Checked radio buttons.
   */
  var remainingOptions = function remainingOptions(checkedBtns) {
    //If only one variant, remove all unavailable classes.
    if (variantFieldsets.length === 1) {
      productVariants.querySelectorAll('.js-unavailable-variant').forEach(function (label) {
        label.classList.remove('js-unavailable-variant');
      });
    }

    // for each checked radio button.
    checkedBtns.forEach(function (radio, index) {
      //First fieldset option
      if (index === 0) {
        //console.log('fire option 1');
        var remainingVariants;
        //if only one variant, then find all the unavailable variants
        if (variantFieldsets.length === 1) {
          remainingVariants = getVariantData().filter(function (variant) {
            return variant.available === false;
          });
        } else if (variantFieldsets.length === 2) {
          //if two variants, then find all the variants from option1 that match the selected radio option, and sort by unavailable first.
          remainingVariants = getVariantData().filter(function (variant) {
            return variant.option1 === checkedBtns[0].value;
          }).sort(function (variant) {
            return variant.available ? 1 : -1;
          });
        } else if (variantFieldsets.length > 2) {
          //if three variants, find all the variants from option1 and option2 that match the selected values for 1 & 2, and sort by unavailable first.
          remainingVariants = getVariantData().filter(function (variant) {
            return variant.option1 === checkedBtns[0].value && variant.option2 === checkedBtns[1].value;
          }).sort(function (variant) {
            return variant.available ? 1 : -1;
          });
        }
        //console.log(index);
        //console.log({remainingVariants});
        remainingVariants.forEach(function (variant) {
          //if one variant, highlight the unavailable options.
          if (variantFieldsets.length === 1) {
            productVariants.querySelector(".js-variant-label[data-label-value=\"".concat(variant.option1, "\"]")).classList.add('js-unavailable-variant');
          }

          //if there is two variants, highlight the unavailable variants, and remove the class if the variant is available. During this array, we may come across the same item twice, therefore we sort by unavailable first to always ensure the available option is always highlighted at the end.
          if (variantFieldsets.length >= 2) {
            if (variant.available) {
              productVariants.querySelector(".js-variant-label[data-label-value=\"".concat(variant.option2, "\"]")).classList.remove('js-unavailable-variant');
            } else {
              productVariants.querySelector(".js-variant-label[data-label-value=\"".concat(variant.option2, "\"]")).classList.add('js-unavailable-variant');
            }
          }

          //if there is three variants, same as above.
          if (variantFieldsets.length > 2) {
            if (variant.available) {
              productVariants.querySelector(".js-variant-label[data-label-value=\"".concat(variant.option3, "\"]")).classList.remove('js-unavailable-variant');
            } else {
              productVariants.querySelector(".js-variant-label[data-label-value=\"".concat(variant.option3, "\"]")).classList.add('js-unavailable-variant');
            }
          }
        });
      }
      //Second Radio Option
      if (index === 1) {
        //console.log('fire option 2');
        var _remainingVariants;
        if (variantFieldsets.length === 2) {
          //if two variants, then find all the variants from option2 that match the selected radio option, and sort by unavailable first.
          _remainingVariants = getVariantData().filter(function (variant) {
            return variant.option2 === checkedBtns[1].value;
          }).sort(function (variant) {
            return variant.available ? 1 : -1;
          });
        } else if (variantFieldsets.length > 2) {
          //if three variants, find all the variants from option2 and option3 that match the selected values for 2 & 3, and sort by unavailable first.
          _remainingVariants = getVariantData().filter(function (variant) {
            return variant.option2 === checkedBtns[1].value && variant.option3 === checkedBtns[2].value;
          }).sort(function (variant) {
            return variant.available ? 1 : -1;
          });
        }
        //console.log(index);
        //console.log({remainingVariants});
        _remainingVariants.forEach(function (variant) {
          //if there is two variants, highlight the unavailable variants, and remove the class if the variant is available. During this array, we may come across the same item twice, therefore we sort by unavailable first to always ensure the available option is always highlighted at the end.
          if (variantFieldsets.length >= 2) {
            if (variant.available) {
              productVariants.querySelector(".js-variant-label[data-label-value=\"".concat(variant.option1, "\"]")).classList.remove('js-unavailable-variant');
            } else {
              productVariants.querySelector(".js-variant-label[data-label-value=\"".concat(variant.option1, "\"]")).classList.add('js-unavailable-variant');
            }
          }

          //if there is three variants, same as above.
          if (variantFieldsets.length > 2) {
            if (variant.available) {
              productVariants.querySelector(".js-variant-label[data-label-value=\"".concat(variant.option3, "\"]")).classList.remove('js-unavailable-variant');
            } else {
              productVariants.querySelector(".js-variant-label[data-label-value=\"".concat(variant.option3, "\"]")).classList.add('js-unavailable-variant');
            }
          }
        });
      }

      //Third Radio Option
      if (index === 2) {
        //console.log('fire option 3');
        //find all the variants from option3 and option1 that match the selected values for 3 & 1, and sort by unavailable first.
        var _remainingVariants2 = getVariantData().filter(function (variant) {
          return variant.option3 === checkedBtns[2].value && variant.option1 === checkedBtns[0].value;
        }).sort(function (variant) {
          return variant.available ? 1 : -1;
        });
        //console.log(index);
        //console.log({remainingVariants});
        _remainingVariants2.forEach(function (variant) {
          if (variant.available) {
            productVariants.querySelector(".js-variant-label[data-label-value=\"".concat(variant.option1, "\"]")).classList.remove('js-unavailable-variant');
          } else {
            productVariants.querySelector(".js-variant-label[data-label-value=\"".concat(variant.option1, "\"]")).classList.add('js-unavailable-variant');
          }
          if (variant.available) {
            productVariants.querySelector(".js-variant-label[data-label-value=\"".concat(variant.option2, "\"]")).classList.remove('js-unavailable-variant');
          } else {
            productVariants.querySelector(".js-variant-label[data-label-value=\"".concat(variant.option2, "\"]")).classList.add('js-unavailable-variant');
          }
        });
      }
    });
  };

  //BG: For each radio button, attach an event listener that triggers when it's checked/unchecked.  
  radioBtns.forEach(function (radio) {
    return radio.addEventListener('change', function () {
      //After a selection has been made, gather all checked options.
      var radioBtnsChecked = productVariants.querySelectorAll('input[type="radio"]:checked');

      //By default, we assume there will always be one radio button checked.
      var optionCombine = radioBtnsChecked[0].value;
      //console.log(radioBtnsChecked[0].value);

      //if there are two variant fields, we assume there will be two checked radio btns so add this to the variable.
      if (variantFieldsets.length >= 2) {
        //console.log(radioBtnsChecked[1].value);
        optionCombine += ' / ' + radioBtnsChecked[1].value;
      }
      //if there are three variant fields, we assume there will be three checked radio btns so add this to the variable.
      if (variantFieldsets.length > 2) {
        //console.log(radioBtnsChecked[2].value);
        optionCombine += ' / ' + radioBtnsChecked[2].value;
      }
      //console.log({optionCombine});
      //BG: with the combined result we search for the variant based on the variant.title.
      var combineVariant = getVariantData().filter(function (variant) {
        return variant.title === optionCombine;
      });
      finalVariant(combineVariant[0]);
      fieldsetLegend(radio);
      remainingOptions(radioBtnsChecked);
    });
  });
  var currentRadioBtnsChecked = productVariants.querySelectorAll('input[type="radio"]:checked');
  remainingOptions(currentRadioBtnsChecked);
};

//only trigger the productVariants if there is more than one variant.
var variantSingle = document.querySelector('.pdp-form .single-variant');
if (!variantSingle) {
  productVariants();
}

// ---------------------------------------------------------------------------
// Product Page - Updating Price in Add to Cart Button on Qty Change
// ---------------------------------------------------------------------------

var priceCalculation = function priceCalculation() {
  var cartActions = document.querySelectorAll('.js-prod-btn-group');
  var buyWithElements = document.querySelectorAll('[data-buy-with]');
  var buyWithPrice = 0;
  buyWithElements.forEach(function (element) {
    var checkbox = element.querySelector('input[type="checkbox"]');
    if (checkbox && checkbox.checked) {
      buyWithPrice += parseInt(element.getAttribute('data-price'));
    }
  });
  cartActions.forEach(function (group) {
    var price = parseInt(group.getAttribute('data-cv-price')),
      quantity = parseInt(group.querySelector('.js-input-quantity').value),
      displayPrice;
    var btnPrice = group.querySelectorAll('.js-total-price');
    displayPrice = (0,_formatMoney__WEBPACK_IMPORTED_MODULE_1__.formatMoney)(price * quantity + buyWithPrice, window.theme.moneyFormat);
    btnPrice.forEach(function (el) {
      el.innerHTML = displayPrice;
    });
  });
};

// ---------------------------------------------------------------------------
// Product Page - Replace rebuy with native upsell this function adds to the upsell products to the form.
// ---------------------------------------------------------------------------

var productAddOns = function productAddOns() {
  var mainProdForms = document.querySelectorAll('.main-prod-form > input[name="id"]');
  var products = document.querySelectorAll('[data-buy-with]');
  products.forEach(function (product, index) {
    index++;
    var checkbox = product.querySelector('input[type="checkbox"]');
    if (checkbox) {
      // Add an event listener to each checkbox
      checkbox.addEventListener('change', function (event) {
        if (event.target.checked) {
          //console.log(`${event.target.value} ${index} checked`);
          mainProdForms.forEach(function (form) {
            form.insertAdjacentHTML("afterend", "<input type=\"hidden\" name=\"items[".concat(index, "][id]\" data-upsell=\"").concat(event.target.value, "\" value=\"").concat(event.target.value, "\" /><input type=\"hidden\" name=\"items[").concat(index, "][quantity]\" data-upsell=\"").concat(event.target.value, "\" value=\"1\" />"));
          });
        } else {
          //console.log(`${event.target.value} ${index} unchecked`);
          document.querySelectorAll("input[data-upsell=\"".concat(event.target.value, "\"]")).forEach(function (el) {
            return el.remove();
          });
        }
        priceCalculation();
      });
    }
  });
};
var productUpsell = document.querySelector('[data-product-upsell]');
if (productUpsell) {
  productAddOns();
}

// ---------------------------------------------------------------------------
// Product Images - Load More
// ---------------------------------------------------------------------------

var images = document.querySelectorAll(".product-image");
var loadMore = document.querySelector(".js-load-more");
loadMore === null || loadMore === void 0 ? void 0 : loadMore.addEventListener('click', function (e) {
  images.forEach(function (element) {
    element.classList.remove('lg:hidden');
  });
  loadMore.classList.add('lg:hidden');
});

// ---------------------------------------------------------------------------
// Product Page - Share Embed (Chain Icon Link) - Copy URL
// ---------------------------------------------------------------------------

var embed_code_button = document.querySelector('.embed-code');
var share_tooltip = document.querySelector('.share-tooltip');
embed_code_button.addEventListener('click', copyUrl);
function copyUrl() {
  // MB: Get the current page URL
  var url = window.location.href;

  // MB: Copy the URL to the clipboard
  navigator.clipboard.writeText(url);
  share_tooltip.classList.remove('opacity-0');
  share_tooltip.classList.add('opacity-1');

  // MB: Setting a timeout to hide tooltip 2 seconds after clicked.
  setTimeout(function () {
    share_tooltip.classList.add('opacity-0');
    share_tooltip.classList.remove('opacity-1');
  }, 2000);
}

// ---------------------------------------------------------------------------
// Product Page - Quantity Selector
// ---------------------------------------------------------------------------

var quantityGroup = document.querySelectorAll('.quantity-selector');
var masterQuantity = document.querySelectorAll('.js-input-quantity');
quantityGroup.forEach(function (group) {
  var minusButton = group.querySelector('.minus-button');
  var plusButton = group.querySelector('.plus-button');
  var currentQuantity = group.querySelector('.js-input-quantity');
  var maxQuantity = document.querySelector('.js-quantity-max').value;
  plusButton.addEventListener('click', function () {
    var currentValue = parseInt(currentQuantity.value);

    //BG: If the current value is less than the max quantity, then we can increment the value.
    if (currentQuantity.value < maxQuantity) {
      masterQuantity.forEach(function (input) {
        input.value = currentValue + 1;
      });
      checkButtonState(currentValue + 1);
      priceCalculation();
    }
  });
  minusButton.addEventListener('click', function () {
    var currentValue = parseInt(currentQuantity.value);

    //BG: If the current value is greater than 1, then we can decrement the value.
    if (currentValue > 1) {
      masterQuantity.forEach(function (input) {
        input.value = currentValue - 1;
      });
      checkButtonState(currentValue - 1);
      priceCalculation();
    }
  });

  // Event listener for quantity input change
  currentQuantity.addEventListener('change', function () {
    var currentValue = parseInt(currentQuantity.value, 10);
    checkButtonState(currentValue);
  });

  // Function to enable/disable plus and minus buttons based on current value
  function checkButtonState(currentValue) {
    if (currentValue >= maxQuantity) {
      plusButton.disabled = true;
      plusButton.classList.add('greyed');
      plusButton.classList.add('cursor-not-allowed');
    } else {
      plusButton.disabled = false;
      plusButton.classList.remove('greyed');
      plusButton.classList.remove('cursor-not-allowed');
    }
    if (currentValue <= 1) {
      minusButton.disabled = true;
      minusButton.classList.add('greyed');
      minusButton.classList.add('cursor-not-allowed');
    } else {
      minusButton.disabled = false;
      minusButton.classList.remove('greyed');
      minusButton.classList.remove('cursor-not-allowed');
    }
  }
});

// ---------------------------------------------------------------------------
// Product Page - Sticky ATC
// ---------------------------------------------------------------------------
function handleIntersection(visible) {
  var sticky = document.querySelector('.sticky-atc');
  if (visible && window.matchMedia("(max-width: 1023px)")) {
    sticky.setAttribute('hidden', '');
  } else {
    sticky.removeAttribute('hidden');
  }
}
function pdpATCObserver() {
  var element = document.querySelector('.js-prod-btn-group--form');
  console.log('element: ', element);
  var observer = new IntersectionObserver(function (entries, observer) {
    entries.forEach(function (entry) {
      handleIntersection(entry.isIntersecting);
    });
  });
  observer.observe(element);
}
pdpATCObserver();
/******/ })()
;